import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { Spacer } from 'components/Utility'

type Props = {
  openModal: () => void
  tel: string
}

const OrderCardHeaderTel: FC<Props> = React.memo((props) => {
  const { openModal, tel } = props

  return (
    <p className={styles.order__header__tel} data-cy={'order-card-header-tel'}>
      <span className={styles.order__header__tel__label}>電話番号：</span>
      <Spacer size={1} axis={'horizontal'} />
      <button
        className={styles.order__header__tel__number}
        data-cy={'order-card-header-tel-button'}
        onClick={openModal}
      >
        {tel}
      </button>
    </p>
  )
})

export default OrderCardHeaderTel
